import { render, staticRenderFns } from "./MenuButtonBlock.vue?vue&type=template&id=c6b2197a&scoped=true&"
import script from "./MenuButtonBlock.vue?vue&type=script&lang=js&"
export * from "./MenuButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./MenuButtonBlock.vue?vue&type=style&index=0&id=c6b2197a&lang=scss&"
import style1 from "./MenuButtonBlock.vue?vue&type=style&index=1&id=c6b2197a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b2197a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6b2197a')) {
      api.createRecord('c6b2197a', component.options)
    } else {
      api.reload('c6b2197a', component.options)
    }
    module.hot.accept("./MenuButtonBlock.vue?vue&type=template&id=c6b2197a&scoped=true&", function () {
      api.rerender('c6b2197a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/header/MenuButtonBlock.vue"
export default component.exports